export enum TaskStatus {
  IN_PROGRESS = 'in_progress',
  READY = 'ready',
  COMPLETED = 'completed',
}

export enum TaskKey {
  addPandaToName = 'addPandaToName',
  refLinkToBio = 'refLinkToBio',
  fillAboutMe = 'fillAboutMe',
  collectAllStones = 'collectAllStones',
  help3CollectAllStones = 'help3CollectAllStones',
  help3Level3 = 'help3Level3',
  invite3 = 'invite3',
  invite10 = 'invite10',
  invite50 = 'invite50',
  premiumChannel = 'premiumChannel',
  sonOfSunChannel = 'sonOfSunChannel',
  domPandChannel = 'domPandChannel',
  pandoraChannel = 'pandoraChannel',
}

export interface TaskProgress {
  value: number;
  total: number;
}

export interface TaskModel {
  id: number;
  description: string;
  xpReward: number;
  cookieReward: number;
  status: TaskStatus;
  progress: TaskProgress;
  key: TaskKey;
}

export interface CompleteTaskBody {
  taskId: number;
}

export interface CompleteTaskResponse {
  cookieBalance: string;
  reward: number;
}

export enum TaskTagTypes {
  TASKS = 'Tasks',
}
